import { Field, Form, Formik } from 'formik'
import React from 'react'
import InputField from '../form/fields/input'
import { RequestButton } from '../request-components/request-components'
import { useUpdateMutation } from '../../queries/period-summaries'
import { PeriodSummary } from '../../api/period-summaries'

interface PreBillingEditFormProps {
  preBilling: PeriodSummary
}

const PreBillingEditForm: React.FC<PreBillingEditFormProps> = ({ preBilling }) => {
  const updateMutation = useUpdateMutation()

  return (
    <Formik
      initialValues={preBilling}
      enableReinitialize
      onSubmit={values => {
        updateMutation.mutate({ invoiceRef: values.invoiceRef, id: preBilling._id.toString() })
      }}
    >
      {() => {
        return (
          <Form autoComplete="off">
            <Field label="Numéro de facture" name="invoiceRef" component={InputField} required />
            <RequestButton color="primary" type="submit" mutation={updateMutation}>
              Modifier
            </RequestButton>
          </Form>
        )
      }}
    </Formik>
  )
}
export default PreBillingEditForm
